import React                   from 'react';
import PropTypes               from 'prop-types';
import {TileDisplayConfigType} from "../Grid2";
import ReloadHelper            from "../../../utils/ReloadHelper";
import {trackCategoriesClick}  from '../../../utils/GAHelper';


const CategoriesListTile = props => {
	const data    = props.data;
	const onClick = e => {
		trackCategoriesClick(data.id, data.linkVX);
		ReloadHelper.reload(data.linkVX, e);
	};

	return (
		<a href={data.linkVX} className={"tile-grid-list--row"} onClick={onClick}>
			<div className="category-list-tile__name">
				{props.data.label}
				<span className="category-list-tile__cams">({data.modelCount})</span>
			</div>
			<div className="category-list-tile__right">
				<div className={"category-list-tile-image__container"}>
					<img src={props.data.imageUrl} className={"category-list-tile__image"} loading={"lazy"} />
				</div>
				<div className="category-list-tile__image-blur-container">
					<div className={"category-list-tile__image-blur-overlay"}></div>
					<img src={props.data.imageUrl} className={"category-list-tile__image category-list-tile__image--blur"} loading={"lazy"} />
				</div>
				<div className="category-list-tile__icon"><i className="icon -icon-single-arrow-right-line"></i></div>
			</div>
		</a>
	);
};

CategoriesListTile.propTypes = {
	data:          PropTypes.object.isRequired,
	displayConfig: TileDisplayConfigType.isRequired,
};

CategoriesListTile.defaultProps = {};

export default CategoriesListTile;
